"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, MapPin } from "lucide-react";
const hubs = [{
  name: "New Delhi",
  x: 200,
  y: 180
}, {
  name: "Gurugram",
  x: 160,
  y: 240
}, {
  name: "Noida",
  x: 240,
  y: 210
}, {
  name: "Ghaziabad",
  x: 250,
  y: 170
}, {
  name: "Faridabad",
  x: 210,
  y: 250
}];
export default function TheDelhiNcrLaunch() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll();
  return <section id="the-delhi-ncr-launch" className="relative w-full overflow-hidden bg-background py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-24">
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-8 transition-all duration-1000 ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            <Badge variant="outline" className="border-[var(--color-chart-5)] text-[var(--color-chart-5)] px-4 py-1 text-sm font-medium tracking-wide uppercase">Phase 1: Winter 2026</Badge>

            <div className="space-y-4">
              <h2 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
                Coming to <span className="text-[var(--color-chart-5)]">Delhi-NCR</span>
              </h2>
              <p className="max-w-xl text-lg leading-relaxed text-muted-foreground">
                The air crisis is real, but so is the solution. We are deploying
                our first Clean Air Bubbles across key hubs in the National
                Capital Region. Experience the sanctuary of pure air where it is
                needed most.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Link to="/WaitlistPage">
                <Button size="lg" className="group text-base px-8 h-12">
                  Join the Waitlist
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              <Link to="/TheSciencePage">
                <Button variant="ghost" size="lg" className="text-base h-12">
                  Learn about the Tech
                </Button>
              </Link>
            </div>

            {}
            <div className="mt-8 grid grid-cols-2 gap-4 sm:hidden">
              {hubs.map((hub, i) => <div key={hub.name} data-index={i} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <span className="relative flex size-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--color-chart-5)] opacity-75"></span>
                    <span className="relative inline-flex rounded-full size-2 bg-[var(--color-chart-5)]"></span>
                  </span>
                  {hub.name}
                </div>)}
            </div>
          </div>

          {}
          <div ref={mapRef} className={`relative flex items-center justify-center transition-all duration-1000 delay-300 ${mapVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            <div className="relative aspect-square w-full max-w-md lg:max-w-lg">
              {}
              <div className="absolute inset-0 -z-10 bg-[var(--color-chart-5)]/5 blur-3xl rounded-full" />
              
              <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-full w-full drop-shadow-xl" aria-label="Map of Delhi-NCR showing installation hubs">
                {}
                <path d="M180 80 C 220 70, 280 100, 300 150 C 320 200, 310 280, 250 320 C 190 360, 120 340, 100 280 C 80 220, 140 90, 180 80 Z" stroke="var(--color-chart-5)" strokeWidth="1.5" strokeDasharray="4 4" className="opacity-40" fill="var(--color-background)" />
                
                {}
                <path d="M200 180 L 160 240 M 200 180 L 240 210 M 200 180 L 250 170 M 200 180 L 210 250" stroke="var(--color-chart-5)" strokeWidth="0.5" className="opacity-20" />

                {}
                {hubs.map((hub, i) => <g key={hub.name} data-index={i}>
                    {}
                    <circle cx={hub.x} cy={hub.y} r="12" className="animate-ping origin-center opacity-20" fill="var(--color-chart-5)" style={{
                  animationDuration: `${2 + i * 0.5}s`
                }} />
                    {}
                    <circle cx={hub.x} cy={hub.y} r="4" fill="var(--color-chart-5)" className="drop-shadow-md" />
                    {}
                    <text x={hub.x} y={hub.y - 15} textAnchor="middle" className="fill-foreground text-[10px] font-medium uppercase tracking-wider opacity-80" style={{
                  fontFamily: 'var(--font-sans)'
                }}>
                      {hub.name}
                    </text>
                  </g>)}
              </svg>

              {}
              <div className="absolute bottom-4 right-4 hidden rounded-xl border bg-card/90 p-4 shadow-lg backdrop-blur-sm sm:block">
                <div className="flex items-center gap-2 mb-2">
                  <MapPin className="size-4 text-[var(--color-chart-5)]" />
                  <span className="text-xs font-semibold text-foreground">Active Zones</span>
                </div>
                <ul className="space-y-1">
                  {hubs.map((hub, i) => <li key={hub.name} data-index={i} className="flex items-center justify-between gap-4 text-xs text-muted-foreground">
                      <span>{hub.name}</span>
                      <span className="block size-1.5 rounded-full bg-[var(--color-chart-5)]"></span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}